import script from "./BinTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BinTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./BinTableLoader.vue?vue&type=style&index=0&id=27112ae4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27112ae4"]])

export default __exports__